const mediaData = [
  {
    title: '独家深扒：某顶流与小花的隐秘恋情时间线全梳理',
    views: '256万',
    duration: '12:38',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20urban%20night%20scene%20with%20blurred%20paparazzi%20style%20lighting%2C%20dramatic%20shadows%20and%20warm%20street%20lamp%20glow%2C%20mysterious%20silhouette%20composition%2C%20editorial%20documentary%20photography%20style%20with%20grainy%20texture%2C%20cinematic%20noir%20aesthetic&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '独家',
  },
  {
    title: '网红圈大地震：多平台头部主播涉嫌刷量造假',
    views: '189万',
    duration: '08:15',
    cover: 'https://readdy.ai/api/search-image?query=Digital%20screen%20displaying%20social%20media%20analytics%20dashboard%20with%20dramatic%20red%20alert%20indicators%2C%20dark%20ambient%20tech%20environment%20with%20glowing%20data%20visualizations%2C%20cyberpunk%20inspired%20aesthetic%20with%20warm%20amber%20accents%2C%20investigative%20journalism%20mood&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '热议',
  },
  {
    title: '综艺翻车现场：当红艺人被导师当众怒斥全程回放',
    views: '143万',
    duration: '05:42',
    cover: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20dramatic%20spotlight%20and%20tension%20atmosphere%2C%20abstract%20representation%20of%20reality%20show%20confrontation%2C%20warm%20stage%20lighting%20contrasting%20with%20dark%20audience%20area%2C%20cinematic%20wide%20shot%20composition%2C%20broadcast%20production%20aesthetic&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '热门',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100">
              <i className="ri-play-circle-fill text-accent-600 text-xl"></i>
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              黑料视频合集
            </h2>
          </div>
          <span className="hidden sm:inline text-sm text-foreground-500 whitespace-nowrap">共 3 期精选</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative aspect-video rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${
                    item.tag === '独家'
                      ? 'bg-primary-500 text-background-50'
                      : item.tag === '热议'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-3xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500 mt-1 inline-block">{item.views} 次播放</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}